/** @jsxImportSource @emotion/react */
import {FormHelperText} from "@mui/material";

export default function FormikHelperText({text, isWarning, ...props}) {
    return isWarning
        ? <FormHelperText sx={{ color: (t) => `${t.palette.warning.main}` }}>{text}</FormHelperText>
        : <FormHelperText>{text}</FormHelperText>
}
